import { SessionStorage } from "./sessionStorage";

class TipMenuEnabledStorage extends SessionStorage {
	public constructor() {
		super({
			storageKey: "tip_menu_enabled",
		});
	}
}

export const tipMenuEnabledStorage = new TipMenuEnabledStorage();
